import React, { useMemo } from "react";
import moment from "moment";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
} from "recharts";

const OrdersStatsCard = ({ orders = [] }) => {
  // 🔥 group by month
  const monthlyData = useMemo(() => {
    const months = {};

    orders.forEach((order) => {
      const m = moment(order.createdAt).format("MMM");

      months[m] = (months[m] || 0) + 1;
    });

    return Object.entries(months).map(([month, count]) => ({
      month,
      count,
    }));
  }, [orders]);

  // 🔥 KPIs
  const total = orders.length;

  const pending = orders.filter((o) => o.orderStatus === "pending").length;

  const cancelled = orders.filter((o) => o.orderStatus === "cancelled").length;

  const today = orders.filter((o) =>
    moment(o.createdAt).isSame(moment(), "day"),
  ).length;

  return (
    <div className=" rounded-2xl border border-navy shadow-sm p-6">
      {/* 🔥 HEADER */}
      <div className="flex justify-between items-start mb-6">
        <div>
          <p className="text-xs uppercase tracking-widest text-gray-400">
            Orders Analytics
          </p>

          <div className="flex items-end gap-3 mt-2">
            <h2 className="text-4xl font-bold text-gray-900">{total}</h2>
            <span className="text-sm text-gray-400 pb-1">total orders</span>
          </div>

          <p className="text-sm text-gray-400 mt-1">
            {pending} pending • {cancelled} cancelled
          </p>
        </div>

        <div className="px-3 py-1 text-xs rounded-full bg-green-50 text-green-600 font-medium">
          Live
        </div>
      </div>

      {/* 🔥 CHART */}
      <div className="h-[260px]">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={monthlyData}>
            <CartesianGrid strokeDasharray="3 3" />

            <XAxis dataKey="month" stroke="#132861" />
            <YAxis allowDecimals={false} stroke="#132861" />

            <Tooltip />

            <Bar dataKey="count" fill="#132861" radius={[6, 6, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      </div>

      {/* 🔥 FOOTER KPI */}
      <div className="grid grid-cols-4 gap-4 mt-6 text-center border-t pt-4">
        <div>
          <p className="text-xs text-gray-400">Total</p>
          <p className="text-lg font-semibold">{total}</p>
        </div>

        <div>
          <p className="text-xs text-gray-400">Pending</p>
          <p className="text-lg font-semibold">{pending}</p>
        </div>

        <div>
          <p className="text-xs text-gray-400">Cancelled</p>
          <p className="text-lg font-semibold">{cancelled}</p>
        </div>

        <div>
          <p className="text-xs text-gray-400">Today</p>
          <p className="text-lg font-semibold">{today}</p>
        </div>
      </div>
    </div>
  );
};

export default OrdersStatsCard;
